<script>
	import { fade } from "svelte/transition";
	import * as validUrl from "valid-url";

	let url = "";
	let shortened = "";
	let copied = false;

	function isDisabled(url) {
		return !validUrl.isWebUri(url);
	}

	async function copyUrl() {
		await navigator.clipboard.writeText(shortened).then(
			function () {
				console.log("Async: Copying to clipboard was successful!");
				copied = true;
			},
			function (err) {
				console.error("Async: Could not copy text: ", err);
			}
		);
	}

	async function submitUrl(event) {
		let resp = await fetch("/link", {
			method: "POST",
			headers: {
				Accept: "application/json",
				"Content-Type": "application/json",
			},
			body: JSON.stringify({ url: url }),
		});
		resp = await resp.json();
		shortened = resp.shortened;
	}
</script>

<main>
	<h1>prtr.dev</h1>
	<form on:submit|preventDefault={submitUrl}>
		<input
			type="text"
			bind:value={url}
			class="url-input mb-0"
			placeholder="https://prtr.dev"
		/>
		<button type="submit" class="submit-btn mb-0" disabled={isDisabled(url)}
			>Shorten!
		</button>
		{#if isDisabled(url) && url.length > 0}
			<p transition:fade class="alert error">Please enter a valid URL.</p>
		{/if}
		{#if shortened.length > 0}
			<p transition:fade class="alert success" on:click={copyUrl}>
				{shortened}
				<span>
					{#if !copied}
					Click to copy
					{:else}
					Copied!
					{/if}
				</span>
			</p>
		{/if}
	</form>
</main>

<style lang="scss">
	main {
		text-align: center;
		padding: 1em;
		max-width: 360px;
		margin: 0 auto;
	}

	h1 {
		color: #ff3e00;
		text-transform: uppercase;
		font-size: 4em;
		font-weight: 100;
	}

	form {
		border: 1px solid #ff3e00;
		padding: 15px;
	}

	.mb-0 {
		margin-bottom: 0;
	}

	.submit-btn,
	.url-input {
		width: 100%;
		margin: 5px 0;
	}

	.alert {
		padding: 5px 0;
		border-radius: 5px;
		margin: 5px 0;
		display: inline-flex;
		align-items: center;
		justify-content: space-around;
		width: 100%;

		&.error {
			border: 1px solid #ff5349;
			background-color: lighten($color: #ff5349, $amount: 15%);
		}

		&.success {
			border: 2px solid #ace1af;
			background-color: lighten($color: #ace1af, $amount: 15%);
			color: #444;
			cursor: pointer;
		}

		span {
			font-size: 0.7em;
			font-weight: 100;
			color: #666;
			margin-left: 15px;
		}
	}
</style>
